module.exports = __webpack_public_path__ + "media/images/user/logo-f663726e3e6871774660b356f7af7e9b.svg";